import Vue from 'vue';

Vue.config.devtools = true
const mutations = {
};

export default mutations;
